var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTaskCheck = function SvgTaskCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M21.333 5.334c2.9.016 4.47.144 5.495 1.169C28 7.674 28 9.56 28 13.33v8c0 3.771 0 5.657-1.172 6.829S23.771 29.33 20 29.33h-8c-3.771 0-5.657 0-6.828-1.171S4 25.102 4 21.33v-8C4 9.56 4 7.674 5.172 6.503c1.024-1.025 2.595-1.153 5.495-1.17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12 17.867 14.286 20 20 14.666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M10.667 4.667a2 2 0 0 1 2-2h6.667a2 2 0 0 1 2 2V6a2 2 0 0 1-2 2h-6.667a2 2 0 0 1-2-2z"
  })));
};
export default SvgTaskCheck;